import { minBreakpoints } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

export const header = css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(${spacing.md});
  margin-bottom: var(${spacing.xs});
`;

export const title = css`
  flex: 1 0 0;
  margin: 0;
  font-size: var(${typography.heading.sizes.sm.fontSize});
  line-height: var(${typography.heading.sizes.sm.lineHeight});

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      font-size: var(${typography.heading.sizes.md.fontSize});
      line-height: var(${typography.heading.sizes.md.lineHeight});
    `,
  )}
`;

export const countrySelectWrapper = css`
  position: relative;
  display: inline-flex;
  align-items: center;
  max-width: 170px;
`;

export const countrySelect = css`
  select {
    appearance: none;
    padding: var(${spacing.xs}) var(${spacing.xl}) var(${spacing.xs}) var(${spacing.md});
    border: 1px solid var(${colors.stroke.interactive});
    border-radius: var(${themeVariables.borderRadius.full.mobile});
    /* Suppress the DropDown's own background-image chevron (see DropDown.styles.ts's
       "select" style) so it doesn't render alongside the Icon-based chevron below. */
    background-image: none;
    background-color: var(${colors.surface.default});
    color: var(${colors.content.interactive});
    /* Form controls don't inherit the document font, so the body family, weight and
       letter-spacing set on <body> by the theme's GlobalStyles are restated here. */
    font-family: var(${typography.body.fontFamily});
    font-weight: var(${typography.body.fontWeight});
    font-size: var(${typography.body.sizes.md.fontSize});
    line-height: var(${typography.body.sizes.md.lineHeight});
    letter-spacing: var(${typography.body.letterSpacing});
  }
`;

export const countrySelectChevron = css`
  position: absolute;
  /* Anchored to a fixed offset (half the select's own rendered height: 1px border + 8px
     vertical padding either side + the 20px body-md line-height = 38px, half = 19px)
     rather than "top: 50%" against countrySelectWrapper. The wrapper also contains the
     DropDown's error feedback message, which renders below the select and grows the
     wrapper's total height when a validation error is shown (e.g. NoDeliveryToCountry).
     Centering against that total height would pull the chevron down out of line with the
     select box itself. The body-md token is a single fixed size at every breakpoint, so
     this offset stays exact rather than trading mobile off against desktop. */
  top: ${pxToRem(19)};
  transform: translateY(-50%);
  right: var(${spacing.md});
  pointer-events: none;
`;

export const timezoneMessageWrapper = css`
  display: flex;
  margin: 0;
  align-items: center;
  gap: var(${spacing.xs});
  margin-bottom: var(${spacing.xs});
`;

export const timezoneMessage = css`
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
  margin: 0;
`;

export const deliveryNotAvailableMessage = css`
  margin: 0;
  padding: 0;
  font-weight: 700;
`;
